import { createFileRoute } from '@tanstack/react-router';
import { JourneysCampaignUnfollowHandoff } from '@/pages/workspaces/automations/[campaignId]/overview/routing';

function JourneysAutomationsUnfollowRoute() {
  const { campaignId } = Route.useParams();
  return <JourneysCampaignUnfollowHandoff campaignId={campaignId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/unfollow',
)({
  component: JourneysAutomationsUnfollowRoute,
});
